import {
  Component, effect,
  EventEmitter, inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  Pipe,
  PipeTransform, signal, WritableSignal
} from '@angular/core';
import {IonicModule} from "@ionic/angular";
import {FormControl, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ModalController} from "@ionic/angular/standalone";
import {addIcons} from "ionicons";
import {arrowBack} from "ionicons/icons";
import {HttpClient} from '@angular/common/http';


@Pipe({
  standalone: true,
  name: 'countryFilter'
})
export class CountryFilterPipe implements PipeTransform {
  transform(value: any, args: string): any {
    if (args) {
      return value.filter((x: any) => x.name.toLowerCase().includes(args.toLowerCase())
        || x.iso.toLowerCase().includes(args.toLowerCase())
        || x.iso3.toLowerCase().includes(args.toLowerCase())
        || x?.phonecode.includes(args));
    } else {
      return value;
    }
  }

}


@Component({
  selector: 'app-select-country',
  templateUrl: './select-country.component.html',
  styleUrls: ['./select-country.component.scss'],
  imports: [CountryFilterPipe, IonicModule, FormsModule, ReactiveFormsModule]
})
export class SelectCountryComponent  implements OnInit, OnChanges {

  @Input() userInput: string = '';
  @Input() isLogin: boolean = false;
  @Output() countrySelected = new EventEmitter();
  selectedCountry = new FormControl();
  phoneCountry: any;
  filterCountryText = '';
  selectedCountryText = '';
  phonecode = '';
  http: HttpClient = inject(HttpClient);
  constructor(public modalController: ModalController) {
    addIcons({arrowBack});
  }
  ngOnChanges(changes: any) {
    if (!this.countryListDb.length) {
      this.getCountryList();
    }
    if (changes.userInput && (changes.userInput.previousValue !== changes.userInput.currentValue.replace('+', ''))) {
      if (changes.userInput === 'undefined' || changes.userInput === null) {
        return;
      }
      if (this.phonecode.length < 4) {
        this.phonecode = changes.userInput.currentValue.replace('+', '');
        this.phoneCountry = this.countryListDb.filter((x: any) => x.phonecode === this.phonecode);
        this.selectedCountry.patchValue(this.phoneCountry[0]);
      } else if (this.phonecode.length < 3 && !this.phonecode.startsWith('1') && !this.phonecode.startsWith('7')) {
        this.selectedCountry.reset();
        this.selectedCountryText = '';
      }
    }
  }
  async ngOnInit() {
    this.getCountryList();
    await this.updateData();
    this.selectedCountry.valueChanges
      .subscribe(v => {
        if (!v) {
          return;
        }
        this.selectedCountryText = `${v.name} (+${v.phonecode})`;
        if (v.phonecode) {
          this.countrySelected.emit('+' + v.phonecode);
        }
      });
  }

  countryListDb: any = [];
  getCountryList() {
    this.http.get('./assets/data/country.json')
      .subscribe(async (data: any) => {
        if (this.phonecode === 'undefined') {
          this.phonecode = '966';
        }
        this.countryListDb = data;
        this.phoneCountry = this.countryListDb.filter((x: any) => x.phonecode === this.phonecode);
        this.selectedCountry.patchValue(this.phoneCountry[0]);
      });
  }
  async pickCountry(x: any) {
    this.selectedCountry.patchValue(x);
    this.selectedCountryText = x.name;
    this.countrySelected.emit('+' + x.phonecode);
    await this.modalController.dismiss();
  }

  async updateData() {
    if (!this.phoneCountry) {
      return;
    }
    if (!this.userInput) {
      if (this.countrySelected) {
        this.selectedCountryText = this.phoneCountry.name;
        this.selectedCountry.patchValue(this.phoneCountry);
        this.countrySelected.emit('+' + this.phoneCountry.phonecode);
      }
    } else {
      this.selectedCountryText = this.phoneCountry.name;
      this.selectedCountry.patchValue(this.phoneCountry);
      this.countrySelected.emit('+' + this.phoneCountry.phonecode);
    }
  }
}
